import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target } from 'lucide-react';
import { projetoService } from '../services/api';

export default function Projetos() {
  const [projetos, setProjetos] = useState<any[]>([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    projetoService.listar()
      .then(r => setProjetos(Array.isArray(r.data) ? r.data : r.data.projetos || []))
      .catch(() => setProjetos([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main>
      <div className="page-hero">
        <h1>Nossos Projetos</h1>
        <p>Iniciativas que promovem saúde, educação, cultura e desenvolvimento social em Marabá e região.</p>
      </div>

      <section className="section-pad">
        <div className="container">
          {loading ? (
            <div className="loading-center"><div className="spinner" /><p>Carregando projetos…</p></div>
          ) : projetos.length === 0 ? (
            <div className="loading-center"><Target size={40} style={{ color: 'var(--borda)' }} /><p>Nenhum projeto cadastrado ainda.</p></div>
          ) : (
            <div className="grid-2">
              {projetos.map((p: any, i: number) => (
                <div className="card" key={p._id} style={{ animation: `fadeUp 0.5s ease ${i * 0.08}s both`, display: 'flex', flexDirection: 'row', overflow: 'hidden' }}>
                  {p.imagemUrl && (
                    <div style={{ width: 180, flexShrink: 0, overflow: 'hidden' }}>
                      <img src={p.imagemUrl} alt={p.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                  )}
                  <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {p.categoria && <span className="badge badge-turquesa">{p.categoria}</span>}
                    <h3 style={{ fontSize: '1.1rem' }}>{p.nome}</h3>
                    <p style={{ fontSize: '0.9rem', flex: 1 }}>{p.descricao?.slice(0, 200)}{p.descricao?.length > 200 ? '...' : ''}</p>
                    {p.status && <span style={{ fontSize: '0.8rem', color: 'var(--turquesa)', fontWeight: 600 }}>● {p.status}</span>}
                    <Link to={`/projetos/${p._id}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--laranja)', fontWeight: 600, fontSize: '0.88rem' }}>
                      Ver detalhes <ArrowRight size={14} />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
